export const percentLabel = (percent: number) => percent > 0 && percent < 1 ? '<1%' : `${Number(percent)}%`